module.exports = __webpack_public_path__ + "img/twitter.3c6660f2.svg";